// extracted by mini-css-extract-plugin
export default {"external":"a3Y3L","noContentPaddings":"b3Y3L"};